module.exports = __webpack_public_path__ + "img/mission.748efd82.jpg";